export default "__VITE_ASSET__B0T4sqkS__"